import React from "react";
import InfiniteScrollTrigger from "components/infinite-scroll/InfiniteScrollTrigger";
import PredictorCard from "components/card/PredictorCard";
import { skeletonGenerator } from "components/infinite-scroll/helpers";
import ProgramSkeleton from "components/infinite-scroll/skeletons/ArticleSkeleton";

const AddPredictors = ({
  selected,
  onChange,
  items,
  isLoadingNextPage,
  hasMoreItems,
  getNextPage,
  page,
  setPage,
  searchResult = [],
}) => {
  return (
    <div
      className="w-full h-full overflow-y-auto"
      style={{
        background: "#e2e2e2",
      }}
    >
      <div className="m-auto">
        <div className="p-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 w-full">
          {(!!searchResult.length ? searchResult : items).map((item) => {
            const predictor = { ...item, id: item.id || item.objectID };
            const isSelected = selected.id === predictor.id;
            return (
              <PredictorCard
                key={predictor.id}
                item={predictor}
                isSelected={isSelected}
                showSecondaryButton={false}
                onCardClick={() => {
                  onChange(predictor);
                }}
              />
            );
          })}
          {isLoadingNextPage && skeletonGenerator(<ProgramSkeleton />)}
          {!searchResult.length && (
            <InfiniteScrollTrigger
              isLoading={isLoadingNextPage}
              hasMoreItems={hasMoreItems}
              callback={getNextPage}
              page={page}
              setPage={setPage}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AddPredictors;
